"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var MenuItem = function (_a) {
    var classes = _a.classes, _b = _a.component, component = _b === void 0 ? 'li' : _b, children = _a.children, dense = _a.dense, _c = _a.disableGutters, disableGutters = _c === void 0 ? false : _c, ListItemClasses = _a.ListItemClasses, _d = _a.selected, selected = _d === void 0 ? false : _d, onClick = _a.onClick, style = _a.style, _e = _a.value, value = _e === void 0 ? null : _e, id = _a.id;
    return (react_1.default.createElement(MenuItem_1.default, { classes: classes, component: component, dense: dense, disableGutters: disableGutters, ListItemClasses: ListItemClasses, selected: selected, onClick: onClick, style: style, value: value, id: id }, children));
};
exports.default = MenuItem;
